import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'src/Components'
import { MobileHeaderModalHeader } from './MobileHeaderModalHeader'
import { MobileHeaderModalBody } from './MobileHeaderModalBody'
import styles from './MobileHeaderMobile.module.scss'
import {
  selectMobileNavIsOpen,
  setMobileNavIsOpen,
} from 'src/store/slices/navbar'

export const MobileHeaderModal = () => {
  const dispatch = useDispatch()
  const open = useSelector(selectMobileNavIsOpen)
  return (
    <Modal
      overrideContent
      className={styles.modal}
      toggle={() => dispatch(setMobileNavIsOpen(false))}
      open={open}
    >
      <MobileHeaderModalHeader />
      <MobileHeaderModalBody />
    </Modal>
  )
}
